import { AppNavBarMenuOptions } from '../types/AppNavBarMenuOptions';

const DefaultOptions: AppNavBarMenuOptions = {
  isDirectoryEnabled: false,
  isEconsultEnabled: false,
  isEvisitEnabled: false,
  isMessagingEnabled: false,
  isScheduleEnabled: false,
  isTeledermEnabled: false
};

const AppNavBarMenuOptionsConst = {
  DefaultOptions
};

export default AppNavBarMenuOptionsConst;
